import CardTemp from './CardTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faParking } from '@fortawesome/free-solid-svg-icons';
library.add(faParking);

function SpruceTabContent() {
  return (
    <div className="row container">
      <CardTemp
        cardLink="/SpruceAnswersList"
        cardIcon={<FontAwesomeIcon icon={faParking} />}
        imgSrc={require('./8 Spruce.jpg')}
        imgTitle=" 8 Spruce Street Garage"
        def1=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Address:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            52 Beekman Street New York NY 10038
          </span>
        </span>
        def2=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Facility:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Garage</span>
        </span>
        def3=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>Hours: </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            24 Hours 7 Days
          </span>
        </span>
        def4=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Operation:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Valet Only</span>
        </span>
        def5=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Capacity:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>175 Cars</span>
        </span>
        def6=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            License:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>Public</span>
        </span>
        def7=<span>
          <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Contact:{' '}
          </span>
          <span style={{ color: 'blue', fontSize: '12px' }}>
            (212) 602-9980 or
          </span>
          <br />
          <span style={{ color: 'blue', fontSize: '12px' }}>
            <a href="mailto:nypparking-east@nyp.org">nypparking-east@nyp.org</a>
          </span>
        </span>
      />
      <br />
      <br />
    </div>
  );
}
export default SpruceTabContent;
